module.exports = __webpack_public_path__ + "static/media/ChromecastDisconnectedIcon.6c1546b7.svg";